import { action } from 'satcheljs';
import { OfficeOnlineApp } from 'owa-file';

export const preloadAppsForFiles = action('WAC_PRELOAD_APPS_FOR_FILES', (fileNames: string[]) => ({
    fileNames,
}));

export const preloadApps = action('WAC_PRELOAD_APPS', (appsToPreload: OfficeOnlineApp[]) => ({
    appsToPreload,
}));

export const appsPreloaded = action('WAC_APPS_PRELOADED', (appsPreloaded: OfficeOnlineApp[]) => ({
    appsPreloaded,
}));
